import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { handleGetRequest } from '../service/GetTemplate';
import { endPoints } from '../Config';

export const complaintOriginOptions = [
    { label: 'Todos los orígenes', value: '' },
    { label: 'WhatsApp · Cliente registrado', value: 'customer' },
    { label: 'WhatsApp · Personal', value: 'staff' },
    { label: 'Portal Syncro', value: 'manual_portal' },
    { label: 'Llamadas', value: 'vapi_call' }
];
export const appendOriginParams = (params, origin) => {
    if (['customer', 'staff'].includes(origin)) {
        params.set('source', 'whatsapp_bot');
        params.set('raisedBy', origin);
    } else if (origin) params.set('source', origin);
};

export default function ComplaintScopeFilters({ origin = '', onOriginChange, teamId = '', onTeamChange, lockedTeamId = '', id = 'complaint' }) {
    const [teams, setTeams] = useState([]);
    useEffect(() => {
        let active = true;
        handleGetRequest(endPoints.getallteams, false).then(response => {
            if (active && Array.isArray(response?.data)) setTeams(response.data.map(team => ({ label: team.name || 'Equipo', value: String(team._id || team.id) })));
        }).catch(() => {});
        return () => { active = false; };
    }, []);
    const selectedTeam = String(lockedTeamId?._id || lockedTeamId || teamId || '');
    const teamOptions = [{ label: 'Todos los equipos', value: '' }, ...teams];
    if (selectedTeam && !teams.some(team => team.value === selectedTeam)) teamOptions.push({ label: lockedTeamId ? 'Mi equipo' : 'Equipo seleccionado', value: selectedTeam });
    return <div className="flex gap-3 flex-wrap mb-3">
        <div><label className="block mb-2" htmlFor={`${id}-origin`}>Origen</label><Dropdown inputId={`${id}-origin`} value={origin} options={complaintOriginOptions} onChange={e => onOriginChange(e.value || '')} /></div>
        <div><label className="block mb-2" htmlFor={`${id}-team`}>Equipo actual{lockedTeamId ? ' (mi equipo)' : ''}</label><Dropdown inputId={`${id}-team`} value={selectedTeam} options={teamOptions} disabled={Boolean(lockedTeamId)} onChange={e => onTeamChange(e.value || '')} /></div>
    </div>;
}
